import { vAutoAnimate } from '@formkit/auto-animate';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('auto-animate', vAutoAnimate);
});
